<div class="container-fluid py-2 py-md-3 px-0">
  @if (event(); as currentEvent) {
  <div class="d-flex flex-wrap justify-content-between align-items-start gap-2 mb-3">
    <h1 class="h2 fw-bold mb-0 break-words" style="min-width: 0;">{{ currentEvent.name }}</h1>
    <span class="badge flex-shrink-0" [ngClass]="currentEvent.active ? 'bg-success' : 'bg-secondary'">
      {{ currentEvent.active ? 'Attivo' : 'Non attivo' }}
    </span>
  </div>

  <app-generic-card [title]="currentEvent.name" [description]="geoLocationService.locationTitle(currentEvent.location)"
    [showHeader]="false" [showTitle]="false" [showDescription]="false">

    <div card-content>
      <div class="event-modal-like border rounded-3 p-3">
        <!-- Main Event Info Grid: Image Left (col-lg-4), Details Right (col-lg-8) -->
        <div class="row g-4 mb-4">
          <div class="col-12 col-lg-4">
            @if (currentEvent.imageUrl) {
            <figure class="mb-0 event-image-container">
              <app-image-lightbox [src]="currentEvent.imageUrl" [alt]="currentEvent.name"></app-image-lightbox>
            </figure>
            } @else {
            <div class="app-content-image-placeholder">
              Locandina non disponibile
            </div>
            }
          </div>

          <div class="col-12 col-lg-8">
            <div class="d-flex flex-column gap-3">
              <!-- Date Range (Left Aligned) -->
              <div class="text-start">
                <h3 class="h4 fw-bold mb-0">
                  <i class="bi bi-calendar-event me-2 text-primary" aria-hidden="true"></i>
                  {{ currentEvent.startDate | dateRange:currentEvent.endDate }}
                </h3>
              </div>

              <!-- Location -->
              <div>
                @if (currentEvent.location?.formalName) {
                  <p class="mb-1 fw-bold">{{ currentEvent.location?.formalName }}</p>
                }

                @if (geoLocationService.mapsUrl(currentEvent.location)) {
                <p class="mb-0">
                  <i class="bi bi-geo-alt-fill text-primary me-1" aria-hidden="true"></i>
                  <a class="location-link" [href]="geoLocationService.mapsUrl(currentEvent.location)" target="_blank" rel="nofollow noopener noreferrer">
                    {{ geoLocationService.mapsLinkLabel(currentEvent.location) }}
                  </a>
                </p>
                } @else {
                <p class="mb-0">
                  <i class="bi bi-geo-alt-fill text-secondary me-1" aria-hidden="true"></i>
                  <span>{{ geoLocationService.locationSubtitle(currentEvent.location) || geoLocationService.locationTitle(currentEvent.location) }}</span>
                </p>
                }
              </div>

              <!-- Complete Description -->
              @if (currentEvent.description) {
              <div class="event-description w-100 break-words" [innerHTML]="sanitizedDescription(currentEvent.description)"></div>
              }

              <!-- Organizzatore / Organizzazioni Ospitate -->
              <div class="row g-3 mt-1">
                <!-- Main Organizer -->
                <div class="col-12 col-md-6">
                  <h2 class="h5 mb-2 fw-bold">
                    @if (eventOrganizations().length > 1) { Organizzatori } @else { Organizzatore }
                  </h2>
                  <div class="d-flex flex-column gap-2">
                    @for (org of eventOrganizations(); track org.id) {
                    <div class="organizer-box d-flex gap-2 align-items-start p-2 border rounded-2"
                         style="cursor: pointer;" [routerLink]="['/organizations/detail', org.id]">
                      <div
                        class="organizer-avatar rounded-circle bg-primary d-flex align-items-center justify-content-center fw-bold text-white flex-shrink-0">
                        @if (org.organizationLogo) {
                        <img [src]="org.organizationLogo" [alt]="org.organizationName"
                          class="organizer-logo" width="64" height="64">
                        } @else {
                        {{ org.organizationName.charAt(0) }}
                        }
                      </div>
                      <div class="flex-grow-1" style="min-width: 0;">
                        <div class="organizer-name fw-bold break-words">{{ org.organizationName }}</div>
                        @if (org.id === currentEvent.organization?.id && organizerMeta(currentEvent)) {
                        <div class="small">{{ organizerMeta(currentEvent) }}</div>
                        }
                        @if (org.id === currentEvent.organization?.id && organizationWebsite()) {
                        <a class="small d-inline-flex align-items-center gap-1 mt-1" [href]="organizationWebsite()"
                          target="_blank" rel="noopener noreferrer" (click)="$event.stopPropagation()">
                          <i class="bi bi-box-arrow-up-right" aria-hidden="true"></i>
                          Sito dell'organizzazione
                        </a>
                        }
                      </div>
                    </div>
                    }
                  </div>
                </div>

                <!-- Hosted Organizations -->
                <div class="col-12 col-md-6">
                  <h2 class="h5 mb-2 fw-bold">Organizzazioni Ospitate / Collaboratrici</h2>

                  @if (currentEvent.invitedOrganizations && currentEvent.invitedOrganizations.length > 0) {
                    <div class="d-flex flex-wrap gap-2 align-items-center mb-2">
                      @for (inv of currentEvent.invitedOrganizations; track inv.id) {
                        <div class="position-relative" style="cursor: pointer;"
                             [routerLink]="['/organizations/detail', inv.id]"
                             [title]="inv.organizationName"
                             [attr.aria-label]="inv.organizationName">
                          <div class="organizer-avatar rounded-circle bg-secondary d-flex align-items-center justify-content-center fw-bold text-white shadow-sm"
                               style="width: 48px; height: 48px; overflow: hidden;">
                            @if (inv.organizationLogo) {
                            <img [src]="inv.organizationLogo" [alt]="inv.organizationName"
                              class="organizer-logo" width="48" height="48" style="object-fit: cover;">
                            } @else {
                            {{ inv.organizationName.charAt(0) }}
                            }
                          </div>
                          @if (canManageEvent()) {
                            <button class="btn btn-danger btn-sm p-0 position-absolute rounded-circle d-flex align-items-center justify-content-center invited-org-remove-btn"
                                    type="button" title="Rimuovi"
                                    (click)="$event.stopPropagation(); onRemoveInvitedOrganization(inv.id, inv.organizationName)">
                              <i class="bi bi-x" aria-hidden="true"></i>
                            </button>
                          }
                        </div>
                      }
                    </div>
                  } @else {
                    <p class="text-muted mb-2 small">Nessuna organizzazione ospitata/collaboratrice presente.</p>
                  }

                  @if (canManageEvent()) {
                    <div class="mt-2 border-top pt-2 border-secondary border-opacity-25">
                      @if (showAddInvitedOrganization()) {
                        <div class="d-flex flex-column gap-2 border rounded p-3 bg-light">
                          <app-generic-search-select
                            [control]="searchOrganizationControl"
                            [options]="availableOrganizations()"
                            [displayFn]="organizationDisplayFn"
                            label="Seleziona organizzazione"
                            placeholder="Cerca organizzazione..."></app-generic-search-select>
                          <div class="d-flex gap-2 justify-content-end mt-2">
                            <button class="btn btn-sm btn-secondary" type="button" (click)="toggleAddInvitedOrganization()">Annulla</button>
                            <button class="btn btn-sm btn-primary" type="button" [disabled]="!searchOrganizationControl.value" (click)="onAddInvitedOrganization()">Aggiungi</button>
                          </div>
                        </div>
                      } @else {
                        <button class="btn btn-outline-primary btn-sm" type="button" (click)="toggleAddInvitedOrganization()"><i class="bi bi-plus-lg me-1" aria-hidden="true"></i>Aggiungi Organizzazione</button>
                      }
                    </div>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="mt-4">
          <h3 class="h4 mb-3 fw-bold">Tavoli GdR</h3>
          <div class="event-tables-gdr-container border border-secondary border-opacity-50 rounded-3 p-3 mb-4">
            @if (gdrTables().length > 0) {
            <div class="event-tables-list d-flex flex-column gap-2">
              @for (table of gdrTables(); track table.id) {
              <div class="mb-4">
                <app-event-game-table-card [gameTable]="table"></app-event-game-table-card>
                <app-game-table-sessions [table]="table" (sessionsChanged)="reloadEvent()"></app-game-table-sessions>
              </div>
              }
            </div>
            } @else {
            <p class="mb-3 text-muted">Nessun tavolo GdR associato a questo evento.</p>
            }

            @if (canAddTable()) {
            <div class="mt-3 border-top pt-3 border-secondary border-opacity-25">
              @if (showCreateGdrTable()) {
              <app-game-table-form title="Crea nuovo tavolo GdR" submitLabel="Crea Tavolo"
                [availableEvents]="[currentEvent]" [availableOrganizations]="authorizedTableOrganizations()"
                [preselectedEvent]="currentEvent" defaultTableType="GDR" [lockTableType]="true" (formSubmit)="onCreateTable($event, 'GDR')" (cancel)="toggleCreateGdrTable()">
              </app-game-table-form>
              } @else {
              <button class="btn btn-primary text-white" style="background-color: var(--bs-orange); border-color: var(--bs-orange);" type="button" (click)="toggleCreateGdrTable()">
                <i class="bi bi-plus-lg me-1" aria-hidden="true"></i>Tavolo
              </button>
              }
            </div>
            }
          </div>

          <h3 class="h4 mb-3 fw-bold">Tavoli GDT</h3>
          <div class="event-tables-gdt-container border border-secondary border-opacity-50 rounded-3 p-3">
            @if (gdtTables().length > 0) {
            <div class="event-tables-list d-flex flex-column gap-3">
              @for (table of gdtTables(); track table.id) {
              <div class="organization-gdt-card border rounded-2 p-3">
                <div class="d-flex flex-wrap justify-content-between align-items-center gap-3 w-100">
                  <div class="d-flex align-items-center gap-3" style="min-width: 0;">
                    @if (table.organization?.organizationLogo) {
                      <img [src]="table.organization!.organizationLogo" alt="Logo" width="48" height="48" class="rounded-circle flex-shrink-0">
                    }
                    <div style="min-width: 0;">
                      <div class="fw-bold fs-5 text-break">{{ table.organization?.organizationName || 'Organizzazione' }}</div>
                      <div class="text-muted small mt-1 text-break">sarà presente all'evento con {{ table.maxPlayers || 0 }} tavoli e {{ table.boardgames?.length || 0 }} giochi</div>
                    </div>
                  </div>
                  <button class="btn btn-primary text-white flex-shrink-0" style="background-color: var(--bs-orange); border-color: var(--bs-orange);" type="button" (click)="openGdtListModal(table)">
                    Lista GdT
                  </button>
                </div>
              </div>
              }
            </div>
            } @else {
            <p class="mb-3 text-muted">Nessun presidio GdT associato a questo evento.</p>
            }

            @if (canAddTable()) {
            <div class="mt-3 border-top pt-3 border-secondary border-opacity-25">
              @if (showCreateGdtTable()) {
              <app-game-table-form title="Aggiungi presenza GdT" submitLabel="Aggiungi"
                [availableEvents]="[currentEvent]" [availableOrganizations]="authorizedTableOrganizations()"
                [preselectedEvent]="currentEvent" defaultTableType="GDT" [lockTableType]="true" (formSubmit)="onCreateTable($event, 'GDT')" (cancel)="toggleCreateGdtTable()">
              </app-game-table-form>
              } @else {
              <button class="btn btn-primary text-white" style="background-color: var(--bs-orange); border-color: var(--bs-orange);" type="button" (click)="toggleCreateGdtTable()">
                <i class="bi bi-plus-lg me-1" aria-hidden="true"></i>Tavolo
              </button>
              }
            </div>
            }
          </div>
        </div>
      </div>
    </div>

    <div card-actions class="d-flex gap-2">
      @if (canManageEvent()) {
      <button class="btn btn-primary" type="button" (click)="onEdit()">
        <i class="bi bi-pencil me-1" aria-hidden="true"></i>Modifica
      </button>
      <button class="btn btn-outline-danger" type="button" (click)="onDelete()">
        <i class="bi bi-trash me-1" aria-hidden="true"></i>Elimina
      </button>
      }
    </div>
  </app-generic-card>
  } @else {
  <div class="text-center py-5">Caricamento evento...</div>
  }
</div>
